import { Injectable, Optional } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';import { AuthService } from '../services';
import { EnvironmentConfig, GeneralService } from '../services';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

  /**
  * Creates an instance of the AuthInterceptor which @implements the class HttpInterceptor
  *
  * @param {AuthService} auth Injected instance of AuthService
  * @param {EnvironmentConfig} config Injected instance of EnvirontmentConfig
  */
  constructor(
    @Optional() private auth: AuthService, 
    @Optional() private config: EnvironmentConfig,
        private gs: GeneralService,     
  private toastr: ToastrService,
  ) { }


  /**
  * Identifies and handles a given HTTP request by adding neccessary authorization headers when needed.
  * @param req — The outgoing request object to handle.
  * @param next
  * The next interceptor in the chain, or the backend if no interceptors remain in the chain.
  *@returns — An observable of the event stream.
 */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken2 = this.auth.getAuthorizationToken()
    if (!this.auth.isLoggedIn || !req.url.match(this.config.api)) {
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => this.handleError(error))
      );
    }
    const authToken = this.auth.getAuthorizationToken()
    const setHeaders: any = { Authorization: `Bearer ${authToken}` }
    if (this.auth.isAdmin === true) {
      setHeaders['x-requested-with'] = 'admin'
    }
    const request = req.clone({ setHeaders })
    return next.handle(request)
  }
  private handleError(err: HttpErrorResponse) { if (err.status >= 400 && err.status <= 500) { 
    this.toastr.error(this.gs.getErrMsg(err)); 
  } return throwError(() => err); 
}

}

